import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "alert__icon" };
const _hoisted_2 = { class: "alert__content" };
const _hoisted_3 = {
    key: 0,
    class: "alert__title"
};
const _hoisted_4 = { class: "alert__message" };
const _hoisted_5 = {
    key: 1,
    class: "alert__links"
};
const _hoisted_6 = ["href"];
import { ref, computed, onMounted } from 'vue';
import Icon from "./Icon.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'AppAlert',
    props: {
        alert: {}
    },
    emits: ['dismiss'],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const timeout = ref();
        let timeoutId = 0;
        onMounted(() => {
            if (props.alert.options.timeout) {
                timeout.value = props.alert.options.timeout;
                timeoutId = window.setTimeout(dismiss, timeout.value);
            }
        });
        function dismiss() {
            emit('dismiss', props.alert);
        }
        function clearTimeout() {
            if (timeoutId) {
                window.clearTimeout(timeoutId);
                timeoutId = 0;
                timeout.value = undefined;
            }
        }
        const timeoutAnimation = computed(() => {
            if (timeout.value === undefined) {
                return '';
            }
            return 'alert-timeout ' + Math.floor(timeout.value / 1000) + 's linear';
        });
        const progressWidth = computed(() => {
            if (!props.alert.options.progress || timeout.value === undefined) {
                return '0';
            }
            return (Math.min(1, Math.max(0, props.alert.options.progress)) * 100) + '%';
        });
        return (_ctx, _cache) => {
            const _component_router_link = _resolveComponent("router-link");
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["alert", ['alert--with-icon', 'alert--' + __props.alert.type]]),
                onMouseenter: _cache[1] || (_cache[1] = ($event) => (clearTimeout()))
            }, [
                (__props.alert.options.closable)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        onClick: _cache[0] || (_cache[0] = _withModifiers(($event) => (dismiss()), ["prevent", "stop"])),
                        class: "alert__dismiss",
                        href: ""
                    }, [
                        _createVNode(Icon, { name: "times" })
                    ]))
                    : _createCommentVNode("", true),
                _cache[4] || (_cache[4] = _createTextVNode()),
                _createElementVNode("div", _hoisted_1, [
                    _createVNode(Icon, {
                        name: __props.alert.type
                    }, null, 8, ["name"])
                ]),
                _cache[5] || (_cache[5] = _createTextVNode()),
                _createElementVNode("div", _hoisted_2, [
                    (__props.alert.title)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(__props.alert.title), 1))
                        : _createCommentVNode("", true),
                    _cache[2] || (_cache[2] = _createTextVNode()),
                    _createElementVNode("span", _hoisted_4, _toDisplayString(__props.alert.message), 1),
                    _cache[3] || (_cache[3] = _createTextVNode()),
                    (__props.alert.options.links && __props.alert.options.links.length > 0)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.alert.options.links, (link, linkIndex) => {
                                return (_openBlock(), _createElementBlock(_Fragment, { key: linkIndex }, [
                                    (link.route)
                                        ? (_openBlock(), _createBlock(_component_router_link, {
                                            key: linkIndex,
                                            to: link.route,
                                            class: "alert__link"
                                        }, {
                                            default: _withCtx(() => [
                                                (link.icon)
                                                    ? (_openBlock(), _createBlock(Icon, {
                                                        key: 0,
                                                        name: link.icon
                                                    }, null, 8, ["name"]))
                                                    : _createCommentVNode("", true),
                                                _createTextVNode(" " + _toDisplayString(link.label), 1)
                                            ]),
                                            _: 2
                                        }, 1032, ["to"]))
                                        : (_openBlock(), _createElementBlock("a", {
                                            key: 1,
                                            href: link.url,
                                            class: "alert__link"
                                        }, [
                                            (link.icon)
                                                ? (_openBlock(), _createBlock(Icon, {
                                                    key: 0,
                                                    name: link.icon
                                                }, null, 8, ["name"]))
                                                : _createCommentVNode("", true),
                                            _createTextVNode(" " + _toDisplayString(link.label), 1)
                                        ], 8, _hoisted_6))
                                ], 64));
                            }), 128))
                        ]))
                        : _createCommentVNode("", true)
                ]),
                _cache[6] || (_cache[6] = _createTextVNode()),
                (timeout.value)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        class: "alert__timeout",
                        style: _normalizeStyle({ animation: timeoutAnimation.value })
                    }, null, 4))
                    : _createCommentVNode("", true),
                _cache[7] || (_cache[7] = _createTextVNode()),
                (__props.alert.options.progress !== undefined)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 2,
                        class: "alert__progress",
                        style: _normalizeStyle({ width: progressWidth.value })
                    }, null, 4))
                    : _createCommentVNode("", true)
            ], 34));
        };
    }
});
